<div class="aiff-detail-container" [testId]="'aiff-detail-container'">
  <nz-spin [nzSpinning]="loading" [testId]="'aiff-detail-spin'">
    <!-- 基本信息部分 -->
    <!-- 在 AiffDetailComponent 的模板中 -->
    <div class="modal-header" [testId]="'aiff-detail-modal-header'">
      <h4 class="modal-title" [testId]="'aiff-detail-modal-title'">{{
        isAdd ? ('tenant.aiff.create' | i18n) : ('tenant.aiff.edit' | i18n)
      }}</h4>
      <button class="close-btn" nz-button nzType="text" (click)="cancel()" [disabled]="submitting" [testId]="'aiff-detail-close-button'">
        <i nz-icon nzType="close" nzTheme="outline" [testId]="'aiff-detail-close-icon'"></i>
      </button>
    </div>
    <nz-card class="info-card" [testId]="'aiff-detail-info-card'">
      <!-- 修改卡片标题区域，添加保存按钮 -->
      <div class="card-header" [testId]="'aiff-detail-card-header'">
        <h3 [testId]="'aiff-detail-basic-info-title'">{{ 'tenant.aiff.basic.info' | i18n }}</h3>
        <div class="card-actions" [testId]="'aiff-detail-card-actions'">
          <button nz-button nzType="primary" (click)="saveAiff()" [nzLoading]="submitting" [testId]="'aiff-detail-save-button'">
            <i nz-icon nzType="save" [testId]="'aiff-detail-save-icon'"></i>{{ 'common.save' | i18n }}
          </button>
        </div>
      </div>
      <form nz-form nzLayout="vertical" [formGroup]="aiffForm" (ngSubmit)="saveAiff()" [testId]="'aiff-detail-form'">
        <div nz-row [nzGutter]="24" class="aiff-basic-form-grid" [testId]="'aiff-detail-form-row'">
          <div nz-col [nzXs]="24" [nzMd]="6" class="aiff-picture-col" [testId]="'aiff-detail-picture-col'">
            <div class="aiff-picture-field" [testId]="'aiff-detail-picture-field'">
              <span class="field-label" [testId]="'aiff-detail-picture-label'">
                <span class="required-mark" aria-hidden="true" [testId]="'aiff-detail-picture-required-mark'">*</span>
                {{ 'tenant.aiff.picture' | i18n }}
              </span>
              <button
                type="button"
                class="aiff-picture-uploader"
                (click)="showIconUploadModal()"
                aria-required="true"
                [attr.aria-label]="'tenant.aiff.picture.upload' | i18n"
                [testId]="'aiff-detail-picture-uploader'"
              >
                <img *ngIf="iconUrl" [src]="iconUrl" [alt]="aiffForm.get('name')?.value || ''" [testId]="'aiff-detail-picture-preview'" />
                <span *ngIf="!iconUrl" class="picture-placeholder" [testId]="'aiff-detail-picture-placeholder'">
                  <i nz-icon nzType="picture" nzTheme="outline"></i>
                  <strong>{{ 'tenant.aiff.picture.upload' | i18n }}</strong>
                  <small>{{ 'tenant.aiff.picture.hint' | i18n }}</small>
                </span>
                <span class="picture-action"><i nz-icon nzType="camera" nzTheme="outline"></i></span>
              </button>
            </div>
          </div>

          <div nz-col [nzXs]="24" [nzMd]="18" class="aiff-main-fields" [testId]="'aiff-detail-main-fields'">
            <nz-form-item [testId]="'aiff-detail-name-form-item'">
              <nz-form-label nzRequired nzFor="name" [testId]="'aiff-detail-name-label'">{{ 'tenant.aiff.name' | i18n }}</nz-form-label>
              <nz-form-control [nzErrorTip]="'tenant.aiff.name.required' | i18n" [testId]="'aiff-detail-name-control'">
                <input
                  nz-input
                  formControlName="name"
                  id="name"
                  [placeholder]="'tenant.aiff.name.placeholder' | i18n"
                  [testId]="'aiff-detail-name-input'"
                />
              </nz-form-control>
            </nz-form-item>

            <nz-form-item [testId]="'aiff-detail-endpoint-form-item'">
              <nz-form-label nzRequired nzFor="endPointUrl" [testId]="'aiff-detail-endpoint-label'">{{
                'tenant.aiff.endpoint.url' | i18n
              }}</nz-form-label>
              <nz-form-control [nzErrorTip]="'tenant.aiff.endpoint.url.required' | i18n" [testId]="'aiff-detail-endpoint-control'">
                <input
                  nz-input
                  formControlName="endPointUrl"
                  id="endPointUrl"
                  [placeholder]="'tenant.aiff.endpoint.url.placeholder' | i18n"
                  [testId]="'aiff-detail-endpoint-input'"
                />
              </nz-form-control>
            </nz-form-item>

            <div [testId]="'aiff-detail-description-col'">
              <nz-form-item [testId]="'aiff-detail-description-form-item'">
                <nz-form-label nzRequired nzFor="description" [testId]="'aiff-detail-description-label'">{{
                  'tenant.aiff.description' | i18n
                }}</nz-form-label>
                <nz-form-control [nzErrorTip]="'tenant.aiff.description.required' | i18n" [testId]="'aiff-detail-description-control'">
                  <textarea
                    [testId]="'aiff-detail-description-textarea'"
                    nz-input
                    formControlName="description"
                    id="description"
                    [placeholder]="'tenant.aiff.description.placeholder' | i18n"
                    [nzAutosize]="{ minRows: 2, maxRows: 3 }"
                  ></textarea>
                </nz-form-control>
              </nz-form-item>
            </div>
          </div>
        </div>
      </form>
    </nz-card>

    <!-- 设置列表部分 -->
    <nz-card *ngIf="aiffId" class="settings-card" [testId]="'aiff-detail-settings-card'">
      <div class="card-header">
        <h3>{{ 'tenant.aiff.settings.info' | i18n }}</h3>
      </div>
      <aiff-setting-list [aiffId]="aiffId" [tenantId]="tenantId" />
    </nz-card>
  </nz-spin>
</div>

<avatar-upload-modal
  [(visible)]="isIconModalVisible"
  [title]="'tenant.aiff.picture.upload' | i18n"
  [aspectRatio]="1"
  [resizeToWidth]="300"
  (cancel)="handleIconModalCancel()"
  (ok)="handleIconCropped($event)"
  [testId]="'aiff-detail-picture-upload-modal'"
/>
